<template lang="pug">
v-app-bar(style="background: #ffffffa6")
  v-layout
    v-app-bar-nav-icon.mt-1(@click="showMenu", color="primary")
      v-icon mdi-menu
    v-flex(hidden-xs-only)
      v-layout.menu-logo-small(align-right)
    v-spacer
    v-app-bar-nav-icon.mt-1.mx-2(color="primary", v-if="allowedNotif")
      v-btn(text, color="primary", height="60px", @click="routeToMenu")
        v-badge(
          v-model="badge",
          :content="notifCount",
          color="secondary",
          offset-x="10",
          offset-y="13"
        )
          v-icon(color="primary", large) mdi-bell-circle-outline
    v-divider(vertical)
    f-dialog-logout(:username="username")
</template>
<script>
import { mapMutations } from "vuex";
export default {
  name: "FToolbar",
  data() {
    return {
      username: "",
      userDetail: null,
      subscribe: null,
      notifCount: null,
      roleId: "",
      alreadySubs: false,
    };
  },
  computed: {
    allowedNotif() {
      return (
        this.roleId == "VRF_USER" ||
        this.roleId == "APR_USER" ||
        this.roleId == "SPV_CORPORATE" ||
        this.roleId == "ADM_CORPORATE"
      );
    },
    badge() {
      return this.notifCount ? true : false;
    },
  },
  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
    showMenu() {
      this.setDrawer(!this.$store.state.app.drawer);
    },
    firstLoadNotification() {
      this.$http.get("api/system/stomp-data").then((success) => {
        if (success.data) {
          this.setNotifRequest(success.data);
        }
      });
    },
    loadSubscription() {
      if (!this.$socket.isStarted()) {
        this.$socket.activate();
      }
      this.subscribe = this.$socket.subscribe("/topic/notif-request", (msg) => {
        let body = msg.body;
        let result = JSON.parse(body);
        this.setNotifRequest(result);
        this.alreadySubs = true;
      });
    },
    setNotifRequest(result) {
      if (
        result.roleId == this.userDetail.user.roleId &&
        result.corporateId == this.userDetail.corporate.corporateId &&
        result.corporateGroupId ==
          this.userDetail.corporate.corporateGroup.corporateGroupId
      ) {
        this.notifCount = result.notifCount
          ? result.notifCount > 9
            ? "9+"
            : result.notifCount
          : null;
      }
    },
    routeToMenu() {
      if (this.roleId == "SPV_CORPORATE" || this.roleId == "ADM_CORPORATE") {
        this.$router.push({ name: "approval-request" }).catch((err) => {});
      } else if (this.roleId == "VRF_USER") {
        this.$router.push({ name: "verify-transaction" }).catch((err) => {});
      } else if (this.roleId == "APR_USER") {
        this.$router.push({ name: "approval-transactions" }).catch((err) => {});
      }
    },
  },
  mounted() {
    this.$session.userDetail().then((item) => {
      this.username = item.username || "";
      this.roleId = item.user.roleId || "";
      this.userDetail = item || null;
      this.loadSubscription();
      this.firstLoadNotification();
    });
  },
};
</script>
<style>
.layout-toolbar {
  max-height: 60px;
  background: white !important;
}
.layout-toolbar .v-toolbar__content {
  height: 50px !important;
}
</style>